import { Input } from 'antd';
import type { Control, FieldErrors } from 'react-hook-form';
import { Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import type { PresetFormValues } from '../../../lib/types';
import { PresetFormItem } from '../form-item';
import styles from '../preset-form.module.scss';

interface BasicSettingsProps {
  control: Control<PresetFormValues>;
  errors: FieldErrors<PresetFormValues>;
  disabled?: boolean;
}

export const BasicSettings = ({ control, errors, disabled }: BasicSettingsProps) => {
  const { t } = useTranslation('translation', { keyPrefix: 'presets.editor.basic' });

  return (
    <div className={styles.fieldsGrid}>
      <PresetFormItem label={t('name')} error={errors.name?.message} required>
        <Controller
          control={control}
          name="name"
          render={({ field }) => (
            <Input
              {...field}
              disabled={disabled}
              placeholder={t('namePlaceholder')}
              maxLength={80}
              showCount
            />
          )}
        />
      </PresetFormItem>

      <PresetFormItem label={t('description')} error={errors.description?.message}>
        <Controller
          control={control}
          name="description"
          render={({ field }) => (
            <Input
              {...field}
              disabled={disabled}
              placeholder={t('descriptionPlaceholder')}
              maxLength={500}
              showCount
            />
          )}
        />
      </PresetFormItem>

      <PresetFormItem
        label={t('policyUrl')}
        error={errors.personal_data_policy_url?.message}
        fullWidth
      >
        <Controller
          control={control}
          name="personal_data_policy_url"
          render={({ field }) => (
            <Input
              {...field}
              value={field.value ?? ''}
              disabled={disabled}
              placeholder={t('policyUrlPlaceholder')}
            />
          )}
        />
      </PresetFormItem>
    </div>
  );
};
